import { render, staticRenderFns } from "./ModalPurchaseRequisitionsProp.vue?vue&type=template&id=372d626d&lang=pug&"
import script from "./ModalPurchaseRequisitionsProp.vue?vue&type=script&lang=js&"
export * from "./ModalPurchaseRequisitionsProp.vue?vue&type=script&lang=js&"
import style0 from "./ModalPurchaseRequisitionsProp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports